
export function preparePhrase(phrase: string, language: string | undefined) {
    language = language?.toLowerCase();
    if (language === 'german')
        phrase = phrase.replace(/^(der|die|das) /g, '');
    if (language === 'swedish')
        phrase = phrase.replace(/^(en|ett|en\/ett) /g, '');
    else if (language === 'english')
        phrase = phrase.replace(/ (smb\/smth|smb|smth|s)/g, '');
    else if (language === 'arabic')
        phrase = phrase.replace(/(َ|ِ|ُ|ْ|ّ|ً)/g, '');
    return phrase;
}
